module.exports = __webpack_public_path__ + "static/media/red-heart.6c5e2b91.webp";